import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import MalletStationBars from './MalletStationBars'

class Bars extends Component {
  render() {
    return (
      <div className={classnames('bars', {'bar-gain-mode': this.props.learnModeOpen})}>
        <MalletStationBars />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    learnModeOpen: state.editor.learnModeOpen
  }
}

export default connect(mapStateToProps, null)(Bars)
